import { render, staticRenderFns } from "./empty-list.vue?vue&type=template&id=b1e4158e"
import script from "./empty-list.vue?vue&type=script&lang=js"
export * from "./empty-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1e4158e')) {
      api.createRecord('b1e4158e', component.options)
    } else {
      api.reload('b1e4158e', component.options)
    }
    module.hot.accept("./empty-list.vue?vue&type=template&id=b1e4158e", function () {
      api.rerender('b1e4158e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/empty-list.vue"
export default component.exports